import { render, staticRenderFns } from "./OfferInfo.vue?vue&type=template&id=667751ea&scoped=true&"
import script from "./OfferInfo.vue?vue&type=script&lang=js&"
export * from "./OfferInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667751ea",
  null
  
)

export default component.exports